import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "@/config/authConfig";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "@/App";
import { ToastContainer } from "react-toastify";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { useEffect } from "react";
import { EventType } from "@azure/msal-browser";
import { createLog } from "@/features/logs/api/createLog";
import { HelmetProvider } from "react-helmet-async";

const queryClient = new QueryClient();

export const AppRoot = () => {
  const [loginSuccess, setLoginSuccess] = React.useState(false);

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS) {
      // @ts-ignore
      msalInstance.setActiveAccount(event.payload.account);
      setLoginSuccess(true);
    }
  });

  useEffect(() => {
    if (!loginSuccess) return;
    createLog({
      action: "Login",
      context: "users",
    }).then(() => {});
  }, [loginSuccess]);

  return (
    <HelmetProvider>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          {/*<MetaTags />*/}
          <App />
          <ToastContainer newestOnTop />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </MsalProvider>
    </HelmetProvider>
  );
};
